import React from 'react';
import { createStyles } from './ExtensionSummary.styles';
import { STUDENTS_VIEW, NavigationView } from '../Navigation/constants';
import { STUDENTS_LIST_STEP } from '../../constants';
import {
  Box,
  Typography,
  useTheme,
  Button,
  Icons,
  Alert,
} from '@ublend-npm/aulaui-core';

type ExtensionSummaryProps = {
  setStep?: (step: string) => void;
  selectedStudentsNumber?: number;
  leftStudentsNumber?: number;
  isConversion?: boolean;
  navigationView: NavigationView;
};

const ExtensionSummary = ({
  selectedStudentsNumber = 0,
  leftStudentsNumber = 0,
  navigationView,
  setStep,
  isConversion = false,
}: ExtensionSummaryProps) => {
  // Get the styles
  const styles = createStyles(useTheme());
  const title = isConversion
    ? `Assign students to this extension (${selectedStudentsNumber})`
    : `Assign students (${selectedStudentsNumber})`;
  const shouldShowLeftStudentButton =
    !isConversion && navigationView === STUDENTS_VIEW && !!leftStudentsNumber;

  return (
    <Box>
      <Box>
        <Typography aria-label={title} component="h3" sx={styles.title}>
          {title}
        </Typography>
        {shouldShowLeftStudentButton && (
          <Button
            kind="secondary"
            size="small"
            endIcon={<Icons.ArrowForward fontSize="small" />}
            onClick={() => setStep && setStep(STUDENTS_LIST_STEP)}
            aria-label="Show students in other cohorts"
          >
            {leftStudentsNumber} in other cohorts
          </Button>
        )}
      </Box>
      {!isConversion && (
        <Alert severity="info">
          Students added here will be removed from their original cohort
        </Alert>
      )}
    </Box>
  );
};

export default React.memo(ExtensionSummary);
